import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-15',
  templateUrl: './dpto15.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto15Component extends DepartmentBase {
  municipalities = [{
    "id": 196,
    "code": "15001",
    "name": "Tunja",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 197,
    "code": "15022",
    "name": "Almeida",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 198,
    "code": "15047",
    "name": "Aquitania",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 199,
    "code": "15051",
    "name": "Arcabuco",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 200,
    "code": "15087",
    "name": "Bel\u00e9n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 201,
    "code": "15090",
    "name": "Berbeo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 202,
    "code": "15092",
    "name": "Bet\u00e9itiva",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 203,
    "code": "15097",
    "name": "Boavita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 204,
    "code": "15104",
    "name": "Boyac\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 205,
    "code": "15106",
    "name": "Brice\u00f1o",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 206,
    "code": "15109",
    "name": "Buenavista",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 207,
    "code": "15114",
    "name": "Busbanz\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 208,
    "code": "15131",
    "name": "Caldas",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 209,
    "code": "15135",
    "name": "Campohermoso",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 210,
    "code": "15162",
    "name": "Cerinza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 211,
    "code": "15172",
    "name": "Chinavita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 212,
    "code": "15176",
    "name": "Chiquinquir\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 213,
    "code": "15180",
    "name": "Chiscas",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 214,
    "code": "15183",
    "name": "Chita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 215,
    "code": "15185",
    "name": "Chitaraque",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 216,
    "code": "15187",
    "name": "Chivat\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 217,
    "code": "15189",
    "name": "Ci\u00e9nega",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 218,
    "code": "15204",
    "name": "C\u00f3mbita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 219,
    "code": "15212",
    "name": "Coper",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 220,
    "code": "15215",
    "name": "Corrales",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 221,
    "code": "15218",
    "name": "Covarach\u00eda",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 222,
    "code": "15223",
    "name": "Cubar\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 223,
    "code": "15224",
    "name": "Cucaita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 224,
    "code": "15226",
    "name": "Cu\u00edtiva",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 225,
    "code": "15232",
    "name": "Ch\u00edquiza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 226,
    "code": "15236",
    "name": "Chivor",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 227,
    "code": "15238",
    "name": "Duitama",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 228,
    "code": "15244",
    "name": "El Cocuy",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 229,
    "code": "15248",
    "name": "El Espino",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 230,
    "code": "15272",
    "name": "Firavitoba",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 231,
    "code": "15276",
    "name": "Floresta",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 232,
    "code": "15293",
    "name": "Gachantiv\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 233,
    "code": "15296",
    "name": "Gameza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 234,
    "code": "15299",
    "name": "Garagoa",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 235,
    "code": "15317",
    "name": "Guacamayas",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 236,
    "code": "15322",
    "name": "Guateque",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 237,
    "code": "15325",
    "name": "Guayat\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 238,
    "code": "15332",
    "name": "G\u00fcic\u00e1n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 239,
    "code": "15362",
    "name": "Iza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 240,
    "code": "15367",
    "name": "Jenesano",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 241,
    "code": "15368",
    "name": "Jeric\u00f3",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 242,
    "code": "15377",
    "name": "Labranzagrande",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 243,
    "code": "15380",
    "name": "La Capilla",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 244,
    "code": "15401",
    "name": "La Victoria",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 245,
    "code": "15403",
    "name": "La Uvita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 246,
    "code": "15407",
    "name": "Villa de Leyva",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 247,
    "code": "15425",
    "name": "Macanal",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 248,
    "code": "15442",
    "name": "Marip\u00ed",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 249,
    "code": "15455",
    "name": "Miraflores",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 250,
    "code": "15464",
    "name": "Mongua",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 251,
    "code": "15466",
    "name": "Mongu\u00ed",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 252,
    "code": "15469",
    "name": "Moniquir\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 253,
    "code": "15476",
    "name": "Motavita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 254,
    "code": "15480",
    "name": "Muzo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 255,
    "code": "15491",
    "name": "Nobsa",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 256,
    "code": "15494",
    "name": "Nuevo Col\u00f3n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 257,
    "code": "15500",
    "name": "Oicat\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 258,
    "code": "15507",
    "name": "Otanche",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 259,
    "code": "15511",
    "name": "Pachavita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 260,
    "code": "15514",
    "name": "P\u00e1ez",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 261,
    "code": "15516",
    "name": "Paipa",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 262,
    "code": "15518",
    "name": "Pajarito",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 263,
    "code": "15522",
    "name": "Panqueba",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 264,
    "code": "15531",
    "name": "Pauna",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 265,
    "code": "15533",
    "name": "Paya",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 266,
    "code": "15537",
    "name": "Paz de R\u00edo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 267,
    "code": "15542",
    "name": "Pesca",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 268,
    "code": "15550",
    "name": "Pisba",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 269,
    "code": "15572",
    "name": "Puerto Boyac\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 270,
    "code": "15580",
    "name": "Qu\u00edpama",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 271,
    "code": "15599",
    "name": "Ramiriqu\u00ed",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 272,
    "code": "15600",
    "name": "R\u00e1quira",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 273,
    "code": "15621",
    "name": "Rond\u00f3n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 274,
    "code": "15632",
    "name": "Saboy\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 275,
    "code": "15638",
    "name": "S\u00e1chica",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 276,
    "code": "15646",
    "name": "Samac\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 277,
    "code": "15660",
    "name": "San Eduardo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 278,
    "code": "15664",
    "name": "San Jos\u00e9 de Pare",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 279,
    "code": "15667",
    "name": "San Luis de Gaceno",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 280,
    "code": "15673",
    "name": "San Mateo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 281,
    "code": "15676",
    "name": "San Miguel de Sema",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 282,
    "code": "15681",
    "name": "San Pablo de Borbur",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 283,
    "code": "15686",
    "name": "Santana",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 284,
    "code": "15690",
    "name": "Santa Mar\u00eda",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 285,
    "code": "15693",
    "name": "Santa Rosa de Viterbo",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 286,
    "code": "15696",
    "name": "Santa Sof\u00eda",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 287,
    "code": "15720",
    "name": "Sativanorte",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 288,
    "code": "15723",
    "name": "Sativasur",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 289,
    "code": "15740",
    "name": "Siachoque",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 290,
    "code": "15753",
    "name": "Soat\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 291,
    "code": "15755",
    "name": "Socot\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 292,
    "code": "15757",
    "name": "Socha",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 293,
    "code": "15759",
    "name": "Sogamoso",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 294,
    "code": "15761",
    "name": "Somondoco",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 295,
    "code": "15762",
    "name": "Sora",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 296,
    "code": "15763",
    "name": "Sotaquir\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 297,
    "code": "15764",
    "name": "Sorac\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 298,
    "code": "15774",
    "name": "Susac\u00f3n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 299,
    "code": "15776",
    "name": "Sutamarch\u00e1n",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 300,
    "code": "15778",
    "name": "Sutatenza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 301,
    "code": "15790",
    "name": "Tasco",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 302,
    "code": "15798",
    "name": "Tenza",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 303,
    "code": "15804",
    "name": "Tiban\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 304,
    "code": "15806",
    "name": "Tibasosa",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 305,
    "code": "15808",
    "name": "Tinjac\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 306,
    "code": "15810",
    "name": "Tipacoque",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 307,
    "code": "15814",
    "name": "Toca",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 308,
    "code": "15816",
    "name": "Tog\u00fc\u00ed",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 309,
    "code": "15820",
    "name": "T\u00f3paga",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 310,
    "code": "15822",
    "name": "Tota",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 311,
    "code": "15832",
    "name": "Tunungu\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 312,
    "code": "15835",
    "name": "Turmequ\u00e9",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 313,
    "code": "15837",
    "name": "Tuta",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 314,
    "code": "15839",
    "name": "Tutaz\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 315,
    "code": "15842",
    "name": "Umbita",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 316,
    "code": "15861",
    "name": "Ventaquemada",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 317,
    "code": "15879",
    "name": "Viracach\u00e1",
    "state": "1",
    "department_code": "15"
  }, {
    "id": 318,
    "code": "15897",
    "name": "Zetaquira",
    "state": "1",
    "department_code": "15"
  }]
}
